import { render, staticRenderFns } from "./ArticleUserView.vue?vue&type=template&id=5a298e2e&"
import script from "./ArticleUserView.vue?vue&type=script&lang=js&"
export * from "./ArticleUserView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports